import { render, staticRenderFns } from "./BetaContentCN.vue?vue&type=template&id=c8f9673e&scoped=true"
import script from "./BetaContentCN.vue?vue&type=script&lang=js"
export * from "./BetaContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f9673e",
  null
  
)

export default component.exports